import type { Organization } from "@/models/organization"
import type {
  IntervalListPublicApiQueryOptions,
  IntervalListResponse,
} from "@/services/core-api/types"
import { httpClient, toHttpError } from "@/utils/api"

interface GetIntervalsParams {
  apiQueryOptions: IntervalListPublicApiQueryOptions & { offset?: number }
  organizationId: Organization["id"]
}

export const getIntervals = async ({
  apiQueryOptions,
  organizationId,
}: GetIntervalsParams): Promise<IntervalListResponse> => {
  try {
    const response = await httpClient.get<IntervalListResponse>(
      `/api/v1/organizations/${organizationId}/intervals`,
      {
        params: apiQueryOptions,
      }
    )

    return response.data
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}
